import React, { useState } from "react";
import { ReactComponent as Verify } from "../../../assets/icons/verify.svg";
import { ReactComponent as VerifiedCheck } from "../../../assets/images/Verified_Check.svg";
import { ReactComponent as WarningTriangle } from "../../../assets/icons/WarningTriangle.svg";
import { ReactComponent as TrevexLogo } from "../../../assets/trevexLogo.svg";
import SearchlistIcon from "../../../assets/icons/searchlisticon.png";
import { ReactComponent as Calender } from "../../../assets/images/calender.svg";
import { ReactComponent as Copy } from '../../../assets/promptIcons/orangeCopy.svg';
import { ReactComponent as RightArrow } from '../../../assets/promptIcons/arrowRightSmall.svg';
import { Link, useNavigate } from "react-router-dom";
import { getCountryByCode, handleCopy } from "../../../utils/Helper";
import { capitalize, toSentenceCaseCP } from "../../../global_functions/global";
import { ReactComponent as Rocket } from "../../../assets/images/rocket.svg";
import ReactGA from "react-ga4";
import { Button, Modal } from "../../common";
import Login from "../../../pages/public/Login";
import { useEffect } from "react";

const CompanyCard = ({ company, isPrompt, setShowPrompt = () => { }, setSelectedPrompt = () => { }, }) => {
  const navigate = useNavigate()
  const [copied, setCopied] = useState(false);
  const [viewMoreModalOpen, setViewMoreModalOpen] = useState(false);
  // const [selectedCompany, setSelectedCompany] = useState(null);
  const verifiedUser = localStorage.getItem('isLoggedIn') === 'true';

  const handleCompany = () => {
    ReactGA.event({
      category: 'VIEW_MORE',
      action: 'VIEW_MORE: Getting Complete View of Company Profile',
      label: `Getting Complete View of Company Profile: "${company?.companyID || company?.wb_win}"`
    });
    localStorage.setItem('lastVisited', `/search/${company?.companyID || company?.wb_win}`);
    
    if (!verifiedUser) {
      setViewMoreModalOpen(true);
      return;
    };
    if(!isPrompt && verifiedUser) {
      navigate(`/search/${company?.companyID || company?.wb_win}`)
    }
    // isPrompt ? null : verifiedUser ?  : null
  }

  const handleViewMoreModalClose = () => {
    localStorage.removeItem('lastVisited')
    setViewMoreModalOpen(false)
  }

  const showGPTPrompt = (prompt) => {
    setSelectedPrompt(prompt);
    setShowPrompt(true);
  }


  return (
    <>
      {viewMoreModalOpen && <Modal modalHandle={handleViewMoreModalClose}>
        {/* <div className="flex"> */}
        <div className="w-[449px] px-[49px] h-[538px] py-8 flex flex-col justify-between">
          <div className="w-full flex justify-center"><TrevexLogo /></div>
          <h1 className="text-[22px] font-semibold text-center">Explore {company?.name}</h1>
          <p className="text-[12px] text-[#787878] font-normal text-center">Log in or register now for <span className="font-bold">FREE</span> to access company information.</p>
          <div>
            <Login modalLogin={true} />
          </div>
        </div>
        {/* </div> */}
      </Modal>}
      <div className={`flex flex-col  ${isPrompt ? "w-full bg-[#F1F1F1] p-6" : "sm:grid md:grid-cols-5 sm:grid-cols-4 grid-cols-1 bg-white p-4 sm:p-7 "} mt-5 border border-gray-200 rounded-lg text-left`} >
        <div className={isPrompt ? "w-full" : "lg:col-span-4 md:col-span-4 sm:col-span-2 lg:border-r sm:border-r-1 col-span-1"}>
          <div className={`company flex ${isPrompt ? "w-full" : "justify-start gap-4"}`}>
            {!isPrompt && <div className="hidden md:block imageicon flex justify-center items-center">
              <img
                src={
                  company?.logo ? company?.logo : SearchlistIcon
                }
                style={{ width: '96px', height: '96px' }}
                className="w-full rounded-lg"
                alt={company?.name || company?.registered_company_name}
              />
            </div>}
            <div className={`mapdetails w-full ${isPrompt ? "w-full" : "md:w-[80%] pl-[-10px]"} flex flex-col items-start justify-around`}>
              <div className="flex items-center w-full gap-2">
                {!isPrompt && <div className="visible md:hidden imageicon flex justify-center items-center">
                  <div className="w-[80px] md:hidden">
                    <img
                      src={
                        company?.name ? SearchlistIcon : company?.logo || SearchlistIcon
                      }
                      style={{ width: '80px', height: '80px' }}
                      className="w-full rounded-lg"
                      alt={company?.name || company?.registered_company_name}
                    />
                  </div>
                </div>}
                <h3 className="sm:text-para3 text-f18 text-secondarytwo font-bold">
                  {isPrompt ? <span className={`text-f18`}>{company?.title}</span> : (company?.name || company?.registered_company_name)}
                </h3>
              </div>
              {isPrompt && <div className='w-full flex flex-wrap gap-2'>
                {/* {company?.tags?.map(tag => (
            ))} */}
                {company.catagory && <div className='rounded-full border border-[#F1F1F1] text-[#3C4848] py-[2px] text-[14px] px-[10px] bg-[#F8F9F9]'>
                  {company.catagory}
                </div>}
              </div>}
              {
                company?.industry || isPrompt ? (
                  <div className={`flex items-center  ${isPrompt ? "bg-white w-full h-full p-3 mt-2" : "sm:mt-0 mt-4 rounded-2xl"}`}>
                    <div className="flex w-full  gap-2">
                      <p style={{ "fontSize": "12px" }}
                        className="text-primaryText font-semibold text-f12 w-full flex items-center sm:p-[2px] px-2 sm:pl-2 capitalize rounded-2xl gap-2 tracking-subheading break-words bg-[#F2F4F7]">
                        {(!isPrompt && company?.industry?.sub_industry?.[0]?.sub_industry) && <Rocket className="hidden md:block sm:w-auto w-20" />}
                        {isPrompt && <span className={`m-1 ${isPrompt && "text-secondary text-f16 font-normal"}`}>{toSentenceCaseCP(company?.description)}</span>}
                        {(!isPrompt && company?.industry?.sub_industry?.[0]?.sub_industry) &&  <span className={`max-w-[100%] p-[2px]`}>{toSentenceCaseCP(company?.industry?.sub_industry?.[0]?.sub_industry)}</span>}

                      </p>
                      {company?.industry?.sub_industry?.length > 1 && <div onClick={handleCompany} className=" cursor-pointer text-primaryText font-semibold text-f12 w-[80px] sm:px-0 capitalize rounded-2xl gap-2 tracking-subheading break-words flex items-center justify-center bg-[#F2F4F7]">+{company?.industry?.sub_industry?.length} More</div>}
                    </div>
                  </div>
                ) : null
              }
              {isPrompt && <div className="w-full flex justify-between items-center mt-4">
                {company?.prompt ? <Button onClick={() => handleCopy(company?.prompt, setCopied)} classes="flex justify-center items-center gap-2 text-[#FB512D] font-semibold border border-[#FB512D] bg-transparent text-[14px] w-[177px] h-[44px] rounded-[4px]">
                  <Copy />{copied ? "Copied!" : "Copy Prompt"}
                </Button> : <></>}
                <Button onClick={() => showGPTPrompt(company)} classes="flex justify-center items-center gap-2 text-[#002940] font-semibold border border-[#012234] bg-transparent text-[14px] w-[175px] h-[44px] rounded-[4px]">
                  View Prompt<RightArrow />
                </Button>
              </div>}
              {!isPrompt && <div className="flex items-center pt-2 sm:pt-0 gap-2 mt-2">
                <div className="flex text-secondary p-1 rounded-full">
                  <span className="flex items-center text-secondarytwo text-f12 font-normal">
                    {company?.country_code &&
                      <img
                        src={`https://flagsapi.com/${company?.country_code}/flat/64.png`}
                        alt={`${company?.country_code} flag`}
                        className="w-4 h-4 object-cover mr-2"
                      />
                    }
                    <span>
                      {capitalize(company?.state) && `${capitalize(company?.state)}, `}
                      {getCountryByCode(company?.country_code)}
                    </span>
                  </span>
                </div>
              </div>}
            </div>
          </div>
        </div>
        {!isPrompt && <div className=" view_profile lg:col-span-1 sm:col-span-1 col-start-5 flex sm:pt-0 pt-2 sm:flex-col items-center sm:items-end justify-between sm:justify-around">
          {
            !isPrompt && (company?.verifiedCompany ? (
              <div className="flex items-center justify-center p-1 px-3 rounded-full" style={{ backgroundColor: '#269758' }}>
                <div style={{ 'width': '12px', 'height': '12px' }}>
                  <VerifiedCheck />
                </div>
                <span className="font-bold px-1 text-f10" style={{ color: '#ecfdf3' }}>
                  VERIFIED
                </span>
              </div>
            ) : company.claimed ? (
              <div className="flex items-center justify-center p-1 px-3 bg-claimed rounded-full">
                <div style={{ 'width': '12px', 'height': '12px' }}>
                  <VerifiedCheck />
                </div>
                <span className="text-slate font-bold px-1 text-f10">
                  ACCESSED
                </span>
              </div>
            ) : company?.secondary ? (
              <div className="bg-highWarning flex items-center justify-center p-1 px-3 rounded-full">
                <div style={{ 'width': '10px', 'height': '10px' }}>
                  <WarningTriangle />
                </div>
                <span className="text-slate font-bold px-1 text-f10">
                  SECONDARY
                </span>
              </div>
            ) : (
              <div style={{ backgroundColor: '#808080' }} className="flex items-center justify-center p-1 px-3 bg-listed rounded-full">
                <div style={{ 'width': '10px', 'height': '10px' }}>
                  <WarningTriangle />
                </div>
                <span className="text-slate font-bold px-1 text-f10">
                  LISTED
                </span>
              </div>
            ))
          }

          {!isPrompt && <div className="text-f14 text-secondary">
            <div
              onClick={handleCompany}
              className="flex items-center gap-1 sm:gap-2 mx-auto text-link border group border-link rounded bg-white font-sans sm:text-f16 my-1 px-1 sm:px-5 py-2 font-bold cursor-pointer"
            >
              <span>View more</span>
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 11L11.5 1M11.5 1H4M11.5 1V8.5"
                  stroke="#002940"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>}
        </div>}
      </div>
    </>
  );
};

export default CompanyCard;
